import { IonCard, IonCardContent, IonCol, IonGrid, IonLabel, IonRow } from "@ionic/react";
import { TabRouterPath } from "@src/app/routing/constant/tabRoute";
import { logEvent } from "@src/appV2/lib/analytics";
import { USER_EVENTS } from "@src/constants";
import { useHistory } from "react-router-dom";

import { FCMRequestData } from "./interfaces";

interface PendingSentHomeRequestsCountProps {
  fcmRequestsData: Array<FCMRequestData>;
  agentId?: string;
}

export function PendingSentHomeRequestsCount(props: PendingSentHomeRequestsCountProps) {
  const { fcmRequestsData, agentId } = props;

  const history = useHistory();
  const fcmRequestsCount = fcmRequestsData ? fcmRequestsData.length : 0;
  const totalEarnings = fcmRequestsData.reduce(
    (total: number, fcmRequest: FCMRequestData) => total + fcmRequest.earnings,
    0
  );
  const goToPendingSentHomeRequestsListPage = () => {
    logEvent(USER_EVENTS.PENDING_SENT_HOME_REQUESTS_CARD_CLICKED, {
      agentId,
    });

    history.push(TabRouterPath.PENDING_SENT_HOME_REQUESTS);
  };

  return (
    <IonCard onClick={goToPendingSentHomeRequestsListPage}>
      <IonCardContent>
        <IonGrid className="no-padding-left">
          <IonRow className="ion-align-items-center">
            <IonCol size="10">
              {totalEarnings > 0 && (
                <IonLabel>
                  <span style={{ fontSize: "10px", color: "#828282" }}>
                    ${totalEarnings.toFixed(2)} total earnings waiting for approval
                  </span>
                </IonLabel>
              )}
              <br></br>
              <IonLabel>
                <span style={{ fontSize: "15px", color: "#333333" }}>
                  {fcmRequestsCount} Pending sent home
                  {fcmRequestsCount < 2 ? " request" : " requests"}
                </span>
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
}
